export const MenuAdmin = [
  {
    title: "Inicio",
    iconStyle: <i className="material-icons">home</i>,
    to: "dashboard",
  },
  {
    title: "Facturación",
    iconStyle: <i className="material-icons"> receipt </i>,
    to: "own-invoice-management",
  },
  {
    title: "Empleados",
    iconStyle: <i className="material-icons"> person_search </i>,
    to: "employee-management",
  },

  {
    title: "Perfil",
    iconStyle: <i className="material-icons">account_circle</i>,
    to: "profile",
  },
  {
    title: "Bolsa de Trabajo",
    iconStyle: <i className="material-icons w-22"  > diversity_2icon </i>,
    to: "https://unioninformatica.org/bolsatrabajo/",
  },

];
